<template lang="pug">
.receivingInformationLayer.allow-replication
  .receivingInformationContent
    i.iconfont.closeIcon(@click.self='close') &#xe60a;
    information(
      v-if='!showSuccess',
      tipDirection='bottom',
      :orderNo='orderNo',
      @success='successHanle',
      title='请完善你的收货信息'
    )
    success(v-else, :hideIcon='true', @close='close')
</template>

<script>
import information from './information'
import success from './success'

export default {
  components: { information, success },
  data() {
    return {
      showSuccess: false,
      orderNo: '',
      reject: () => {},
      resolve: () => {},
    }
  },
  methods: {
    successHanle() {
      this.showSuccess = true
    },
    close() {
      if (this.saveButtonCurrentType) return
      this.$el.parentElement.removeChild(this.$el)
      if (this.showSuccess) {
        this.resolve()
      } else {
        this.reject()
      }
    },
  },
}
</script>

<style lang="less" scoped>
.receivingInformationLayer {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 100;
}
.receivingInformationContent {
  padding: 30px 39px;
  background: white;
  width: 400px;
  border-radius: 10px;
  min-height: 277px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.closeIcon {
  font-size: 20px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}
</style>
<style lang="less">
.receivingInformationLayer {
  .rece-info .rece-info-form .form-item {
    margin-bottom: 22px;
  }
  .success-content-tip {
    width: auto !important;
  }
  .errortip {
    font-size: 12px !important;
  }
  .submit-button {
    margin-bottom: 0 !important;
    background: #24cc7c !important;
  }
  .submit-button.disabled{
    background: #ccc!important;
  }
  .success-content {
    padding: 0 !important;
    .submit-button {
      margin-top: 58px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Stu/receivingInformation/app.vue